// Google Analytics 4 wrapper (via react-ga4).
//
// Privacy-first design:
//   - Runs ONLY in production builds (never pollutes data during local dev).
//   - Initializes ONLY after the user grants cookie consent (opt-in), so it is
//     GDPR/UK-friendly for a worldwide audience.
//   - The Measurement ID comes from REACT_APP_GA_ID (configurable per env).
//
// Nothing here loads or sends data until `initAnalytics()` is called, which the
// app does only when consent === "granted".

import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_ID;
const IS_PROD = process.env.NODE_ENV === "production";

let initialized = false;

// Whether analytics is allowed to run at all (prod + a configured ID).
export const analyticsAvailable = () => IS_PROD && !!GA_ID;

// Initialize GA and record the first page view. Safe to call multiple times.
export const initAnalytics = () => {
  if (!analyticsAvailable() || initialized) return;
  try {
    ReactGA.initialize(GA_ID);
    initialized = true;
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  } catch (e) {
    // Never let analytics break the app.
    initialized = false;
  }
};

// Generic event helper (no-op until initialized).
export const trackEvent = (name, params = {}) => {
  if (!initialized) return;
  try {
    ReactGA.event(name, params);
  } catch (e) {
    /* ignore */
  }
};

// ---- Named event helpers (keep call sites readable) ----
export const trackLogin = (method) => trackEvent("login", { method }); // "cloud" | "local"
export const trackGoalCompleted = () => trackEvent("goal_completed");
export const trackRememberAdded = () => trackEvent("remember_added");
export const trackConferenceAdded = () => trackEvent("conference_added");
export const trackPanelReorder = (panel, direction) =>
  trackEvent("panel_reorder", { panel, direction });
export const trackPWAInstall = () => trackEvent("pwa_install");
